import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4503a926&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4503a926",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4503a926')) {
      api.createRecord('4503a926', component.options)
    } else {
      api.reload('4503a926', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4503a926&scoped=true", function () {
      api.rerender('4503a926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pointsStore/creatStore/index.vue"
export default component.exports